import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IRoleTemplate } from '@obvious.tech/constellation'

export const RoleTemplate = defineEntity('RoleTemplate', {
  endpoint: 'authentication/api/RoleTemplate',
  schema: SNoop<IRoleTemplate>(),
})
